



































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentModalCriarTabelaPreco extends Vue {
  loadSave: boolean = false
  $refs!: { form: any }

  form: any = {
    valid: true,
    nome: [(v: string) => !!v || 'Campo obrigatório'],
  }

  get loadingSave() { return this.loadSave }
  set loadingSave(value: boolean) { this.loadSave = value }

  get modalTabelaPreco() { return this.getFinanceiroStore.modal.criarTabelaPreco }
  set modalTabelaPreco(value: boolean) { this.getFinanceiroStore.setModal({ name: 'criarTabelaPreco', value }) }

  get nome() { return this.getFinanceiroStore.nome }
  set nome(value: string) { this.getFinanceiroStore.setNome(value) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  async save() {
    if (this.$refs.form.validate()) {
      this.loadingSave = true
      const response = await this.getFinanceiroStore.criarTabelaPreco()
      if (response.success) {
        await this.getFinanceiroStore.getTabelaPrecoDetails(1)
        this.modalTabelaPreco = false
        EventBus.$emit('setSnackbar', { show: true, text: 'Profissional alterado com sucesso!', icon: 'done', color: '#2E7D32', timeout: 4000 })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao salvar!', icon: 'warning', color: '#C62828' })
      }
      this.loadingSave = false
    }
  }

  @Watch('modalTabelaPreco')
  onChangeModalAlterarPrestador(value: boolean) {
    if (!value) {
      const id = this.getFinanceiroStore.idForLoadItensRepasse
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
    }
  }
}
